/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { DocumentVersion } from './DocumentVersion';
import {
    DocumentVersionFromJSON,
    DocumentVersionFromJSONTyped,
    DocumentVersionToJSON,
    DocumentVersionToJSONTyped,
} from './DocumentVersion';

/**
 * 
 * @export
 * @interface ListDocumentVersionsResponse
 */
export interface ListDocumentVersionsResponse {
    /**
     * 
     * @type {Array<DocumentVersion>}
     * @memberof ListDocumentVersionsResponse
     */
    data: Array<DocumentVersion>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListDocumentVersionsResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListDocumentVersionsResponse interface.
 */
export function instanceOfListDocumentVersionsResponse(value: object): value is ListDocumentVersionsResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListDocumentVersionsResponseFromJSON(json: any): ListDocumentVersionsResponse {
    return ListDocumentVersionsResponseFromJSONTyped(json, false);
}

export function ListDocumentVersionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDocumentVersionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(DocumentVersionFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListDocumentVersionsResponseToJSON(json: any): ListDocumentVersionsResponse {
      return ListDocumentVersionsResponseToJSONTyped(json, false);
  }

  export function ListDocumentVersionsResponseToJSONTyped(value?: ListDocumentVersionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(DocumentVersionToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

